import { LandingHeader } from "../landing/navigation/LandingHeader";
import { LandingHeaderMenuItem } from "../landing/navigation/LandingHeaderMenuItem";
import { Logo } from "./Logo";

export const Header = ({ className }: { className?: string }) => {
  return (
    <LandingHeader
      className={className}
      withBackground
      variant="primary"
      fixed
      logoComponent={<Logo />}
    >
      <LandingHeaderMenuItem href="/#features">
        {"Features"}
      </LandingHeaderMenuItem>
      <LandingHeaderMenuItem href="/#whos-it-for">
        {"Who is it for?"}
      </LandingHeaderMenuItem>
      <LandingHeaderMenuItem type="button" href="/#faq">
        {"FAQ"}
      </LandingHeaderMenuItem>
    </LandingHeader>
  );
};

export default Header;
